import styled from "styled-components";
import {Button, Row} from "antd";

export const ButtonsRow = styled(Row)`
    gap: 8px;
    display: flex;
    flex-wrap: wrap;

    @media (min-width: 1200px) {
        justify-content: flex-end;
    }
    @media (max-width: 1200px) and (min-width: 768px) {
        justify-content: flex-start;
    }
    @media (max-width: 767px) {
        justify-content: flex-start;
        gap: 12px;
        margin-top: 16px;
        flex-direction: column;

        .ant-btn {
            flex: 1;
            min-width: 120px;
            margin-bottom: 8px;
        }
    }
`;

export const WaitingApproveButton = styled(Button)`
    color: "red";
    &:hover,
    &:active,
    &:focus {
        border-color: red;
    }
`;
